import React, { useEffect, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import "../components/style/service-details.scss";
import TopHeader from "../components/TopHeader";

// Lazy load components
const Navbar = lazy(() => import("../components/Navbar"));
const MiniHero = lazy(() => import("../components/MiniHero"));
const ContactInfo = lazy(() => import("../components/ContactInfo"));
const Footer = lazy(() => import("../components/Footer"));
const Loading = lazy(() => import("../components/Loading"));
function AccountsSystemsStructuring() {
  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Accounts & Systems Structuring - Lam Al Arabia</title>
        <meta
          name="description"
          content="Lam Al Arabia provides expert account structuring services, including financial policies, bookkeeping, payroll management, and system optimization to enhance business efficiency."
        />
        <meta name="robots" content="index, follow" />
        <meta
          property="og:title"
          content="Accounts & Systems Structuring - Lam Al Arabia"
        />
        <meta
          property="og:description"
          content="Enhance your financial management with our structured accounting and system optimization services. Ensure compliance and improve operational efficiency with Lam Al Arabia."
        />
        <meta
          property="og:url"
          content="https://lam.com.sa/services/accounts-systems-structuring"
        />
      </Helmet>

      <Suspense fallback={<Loading />}>
        <TopHeader />
        <Navbar page="accounts-systems-structuring" />
        <MiniHero title="Accounts & Systems Structuring" />

        <div className="container mx-auto px-lg-5 py-5 service-details">
          <h2 className="text-3xl font-bold mb-4">
            Accounts & Systems Structuring
          </h2>
          <p className="mb-6">
            Our Accounts & Systems Structuring service is designed to help
            businesses establish and optimize their financial and administrative
            frameworks. We provide end-to-end solutions to enhance financial
            clarity, regulatory compliance, and operational efficiency.
          </p>
          <h3>Our Comprehensive Services</h3>
          <ul className="space-y-4 list-disc pl-5">
            <li>
              <strong>Financial Policies and Procedures:</strong> Developing and
              implementing financial policies, administrative regulations, and
              structured procedures.
            </li>
            <li>
              <strong>Accounting System Setup:</strong> Designing and
              structuring the chart of accounts, cost accounting systems, and
              financial reporting frameworks.
            </li>
            <li>
              <strong>Regulatory Compliance and Standardization:</strong>{" "}
              Ensuring financial practices align with international accounting
              standards and regulations.
            </li>
            <li>
              <strong>Document Workflow and Control:</strong> Creating and
              maintaining an efficient documentation system to enhance accuracy
              and accountability.
            </li>
            <li>
              <strong>Payroll and Payments Management:</strong> Implementing
              payroll systems, managing employee compensation, and ensuring
              compliance.
            </li>
            <li>
              <strong>Financial Reporting and Analysis:</strong> Generating
              financial reports, balance sheets, and income statements to aid
              decision-making.
            </li>
            <li>
              <strong>Integration of Accounting and Inventory Systems:</strong>{" "}
              Enhancing coordination between accounting, payroll, and inventory
              systems.
            </li>
          </ul>

          <div className="mt-8">
            <h3 className="text-2xl font-bold">Why Choose Us?</h3>
            <p className="mt-2">
              With our expertise, we ensure that your accounting and financial
              systems are optimized for efficiency, compliance, and growth. Our
              structured approach helps businesses manage their finances
              effectively while reducing risks and enhancing profitability.
            </p>
          </div>

          <div className="mt-6">
            <p className="font-semibold">
              Contact us today to learn more about how our Accounts & Systems
              Structuring service can improve your business operations.
            </p>
          </div>
        </div>

        <ContactInfo />
        <Footer />
      </Suspense>
    </>
  );
}

export default AccountsSystemsStructuring;
